import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // 1. Use the HTTP backend to load translations from your /public folder
  .use(HttpApi)
  
  // 2. Use the browser language detector
  .use(LanguageDetector)
  
  // 3. Pass the i18n instance to react-i18next
  .use(initReactI18next)
  
  // 4. Initialize i18next
  .init({
    // ----- Your Configuration -----
    
    // Default language
    fallbackLng: 'en',
    
    // Supported languages
    supportedLngs: ['en', 'te'],

    // Default namespace to load
    // (We put our translations in 'common.json')
    defaultNS: 'common',
    ns: ['common'],

    // ----- Plugin Configuration -----

    // Config for i18next-http-backend
    // Where to find the translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Config for i18next-browser-languagedetector
    // Order of detection and what to cache
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    // ----- React Configuration -----
    
    // Enable suspense for lazy-loading
    // This is the key to performance!
    react: {
      useSuspense: true,
    },
    
    // Debugging (optional: set to false in production)
    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;